import(/* webpackMode: "eager" */ "/var/www/appagent/src/app/register/page.tsx");
